var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.78 118.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin {\n        fill: #caba8b;\n      }\n      .cls-2 {\n        fill: #dadada;\n      }\n      .cls-3 {\n        fill: #1e4900;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surprised"
  }, /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M136.09,41.69c2,14.1-36.39,6.15-68.83,10.66S2.05,57.79.09,43.69s27.56-37.47,60-42C103.09-4.31,134.13,27.59,136.09,41.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 71.2,
    cy: 77.2,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 71.2,
    cy: 61.17,
    rx: 64.79,
    ry: 46.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.69,38a28.07,28.07,0,0,0-17.45,6.06l9.85,16.63L47.5,53.53A28.2,28.2,0,1,0,72.69,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M218.69,40.74c-2,14.1,36.39,6.15,68.83,10.66s65.21,5.44,67.17-8.66-27.56-37.47-60-42C251.69-5.26,220.65,26.64,218.69,40.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 283.58,
    cy: 76.24,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 283.58,
    cy: 60.69,
    rx: 64.79,
    ry: 46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.09,37.05a28.07,28.07,0,0,0-17.46,6.06l9.85,16.63-17.59-7.16a28.2,28.2,0,1,0,25.2-15.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset29);
export default __webpack_public_path__ + "static/media/Asset 29.ec5ccb19.svg";
export { ForwardRef as ReactComponent };